document.addEventListener('DOMContentLoaded', function () {

    const stickyButton = document.getElementById('indidha-sticky-button');

    if (!stickyButton) return;

   const stickyBar = document.getElementById('indidha-sticky-atc');

const sectionId = stickyBar.dataset.section;

const productForm = document.querySelector(
    `#productForm-${sectionId}`
);

    if (!productForm) return;

    const originalButton = productForm.querySelector('.js-product-form-submit-btn');

    if (!originalButton) return;

    function syncButtonState() {

        const buttonText = originalButton.querySelector('.js-product-form-submit-btn-text');

        stickyButton.disabled = originalButton.disabled;

        if (originalButton.classList.contains('loading')) {
            stickyButton.textContent = 'ADDING...';
            return;
        }

        if (originalButton.disabled) {
            stickyButton.textContent = 'SOLD OUT';
            return;
        }

        if (buttonText) {
            stickyButton.textContent = buttonText.textContent.trim().toUpperCase();
        } else {
            stickyButton.textContent = 'ADD TO CART';
        }
    }

    syncButtonState();

    stickyButton.addEventListener('click', function () {

        if (stickyButton.disabled) return;

        originalButton.click();

    });

    const observer = new MutationObserver(syncButtonState);

    observer.observe(originalButton, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['disabled', 'class']
    });

});